/* eslint-disable react-hooks/exhaustive-deps */
import { Box, useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { Ad } from "react-ad-manager";
import { AdType } from "react-ad-manager/dist/types";


const ResponsiveAdBanner = (props: AdType) => {
	const bannerScalerRef = useRef<HTMLDivElement | null>(null);
	const containerRef = useRef<HTMLDivElement | null>(null);
	const router = useRouter();
	const isMobile = useMediaQuery('(max-width: 600px)');

	const resizeBanner = () => {
		if (bannerScalerRef.current && containerRef.current) {
			const containerWidth = containerRef.current.offsetWidth;
			const maxBannerWidth = isMobile ? 600 : 1280;
			const scale = Math.min(containerWidth / maxBannerWidth, 1);
			bannerScalerRef.current.style.transform = `scale(${scale})`;
		}
	};

	useEffect(() => {
		window.addEventListener('resize', resizeBanner);
		window.addEventListener('load', resizeBanner);

		if (bannerScalerRef.current && containerRef.current) {
			setTimeout(() => {
				resizeBanner();
			}, 100);
		}

		return () => {
			window.removeEventListener('resize', resizeBanner);
			window.removeEventListener('load', resizeBanner);
		};
	}, [bannerScalerRef, containerRef, isMobile, router.isReady])
		
	return (
		<Box
			ref={containerRef}
			sx={{
				maxWidth: '100%',
				overflowX: 'hidden',
				display: 'block',
				margin: '0 auto'
			}}
		>
			<Box
				ref={bannerScalerRef}
				sx={{
					width: 'fit-content',
					transformOrigin: 'top left',
					margin: '0 auto'
				}}
			>
				<Ad
					adUnit={props.adUnit}
					name={props.name}
					size={props.size}
				/>
			</Box>
		</Box>
	)
}

export default ResponsiveAdBanner;